export const ContentContainer = {
  display: "flex",
  alignItems: "center",
  columnGap: "14px",
}

export const TextContainer = {
  display: "flex",
  flexDirection: "column",
}

export const Icon = {
  width: 46,
  height: 46,
}
